import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type NoteIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const NoteIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: NoteIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Note'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 17 17'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.75 10.75C15.75 11.192 15.5744 11.616 15.2618 11.9285C14.9493 12.2411 14.5254 12.4167 14.0833 12.4167H4.08333L0.75 15.75V2.41667C0.75 1.97464 0.925595 1.55072 1.23816 1.23816C1.55072 0.925595 1.97464 0.75 2.41667 0.75H14.0833C14.5254 0.75 14.9493 0.925595 15.2618 1.23816C15.5744 1.55072 15.75 1.97464 15.75 2.41667V10.75Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
